import { ApiClient } from "./api-client";

export function getRegistrations() {
  return ApiClient.getInstance().get('/registration').catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function getRegistration(registrationId) {
  return ApiClient.getInstance().get('/registration/:id', { urlParams: { id: registrationId } }).catch((error) => {
    console.error('Error fetching user data:', error);
    throw error;
  });
}

export function createRegistration(firstname, lastname, email, company, role, companyManager) {
  return company ?
    ApiClient.getInstance().post('/registration', { firstname: firstname, lastname: lastname, email: email, companyId: company, roleId: role, companyManager: companyManager }).catch((error) => {
      console.error('Error creating registration:', error);
      throw error;
    }) :
    ApiClient.getInstance().post('/registration', { firstname: firstname, lastname: lastname, email: email, roleId: role, companyManager: companyManager }).catch((error) => {
      console.error('Error creating registration:', error);
      throw error;
    });
}

export function confirmRegistration(registrationId, password, tosVersion = "0.1") {
  return ApiClient.getInstance().post('/registration/confirm', { uuid: registrationId, password: password, tosVersion: tosVersion }).catch((error) => {
    console.error('Error confirming registration:', error);
    throw error;
  });
}

export function resendRegistration(registrationId) {
  return ApiClient.getInstance().post('/registration/resend', { uuid: registrationId }).catch((error) => {
    console.error('Error resending registration:', error);
    throw error;
  });
}

export function deleteRegistration(registrationId) {
  return ApiClient.getInstance().delete('/registration/:id', { urlParams: { id: registrationId } }).catch((error) => {
    console.error('Error deleting registration:', error);
    throw error;
  });
}